/**
 * 포인트/리워드 페이지 상수 및 번역
 */
import imgBrandLogo from 'figma:asset/3d942e2d23030cb3b6df3d976297b7e976331839.png';
import type { Franchise, PointsTranslations, PointsData } from './types';
import type { Locale } from '@/config/locales';

export const translations = {
  ko: {
    tabs: {
      points: '포인트'
    },
    totalPoints: '사용 가능 포인트',
    viewDetails: '받은 혜택 자세히 보기',
    pointsEarned: '적립',
    pointsUsed: '사용',
    pointsExpiring: '만료',
    brandPoints: '맥도날드',
    stores: '개 지점',
    pointsGuideTitle: '포인트 가이드',
    pointsGuide1: '결제 시 포인트가 자동 적립됩니다',
    pointsGuide2: '포인트는 적립일로부터 1년간 유효합니다',
    pointsGuide3: '브랜드별 포인트는 해당 브랜드에서만 사용 가능합니다',
    viewLocation: '위치 보기',
    whatsapp: 'WhatsApp',
    pickup: '바로 픽업',
    open: '영업중',
    closed: '영업종료',
    category: '패스트푸드',
    backToBrands: '브랜드 목록으로',
    availableStores: '사용 가능 매장'
  },
  es: {
    tabs: {
      points: 'Puntos'
    },
    totalPoints: 'Puntos disponibles',
    viewDetails: 'Ver detalles de beneficios',
    pointsEarned: 'Puntos ganados',
    pointsUsed: 'Puntos usados',
    pointsExpiring: 'Por vencer',
    brandPoints: 'McDonald\'s',
    stores: ' tiendas',
    pointsGuideTitle: 'Guía de puntos',
    pointsGuide1: 'Se acumulan automáticamente puntos en cada pago',
    pointsGuide2: 'Los puntos son válidos por 1 año desde la fecha de acumulación',
    pointsGuide3: 'Los puntos de cada marca solo se pueden usar en esa marca',
    viewLocation: 'Ver ubicación',
    whatsapp: 'WhatsApp',
    pickup: 'Recoger ahora',
    open: 'Abierto',
    closed: 'Cerrado',
    category: 'Comida rápida',
    backToBrands: 'Volver a marcas',
    availableStores: 'Tiendas disponibles'
  },
  en: {
    tabs: {
      points: 'Points'
    },
    totalPoints: 'Available Points',
    viewDetails: 'View benefits details',
    pointsEarned: 'Points Earned',
    pointsUsed: 'Points Used',
    pointsExpiring: 'Expiring',
    brandPoints: 'McDonald\'s',
    stores: ' stores',
    pointsGuideTitle: 'Points Guide',
    pointsGuide1: 'Earn points automatically on every payment',
    pointsGuide2: 'Points are valid for 1 year from the date earned',
    pointsGuide3: 'Brand-specific points can only be used at that brand',
    viewLocation: 'View location',
    whatsapp: 'WhatsApp',
    pickup: 'Pickup now',
    open: 'Open',
    closed: 'Closed',
    category: 'Fast food',
    backToBrands: 'Back to Brands',
    availableStores: 'Available Stores'
  },
  pt: {
    tabs: {
      points: 'Pontos'
    },
    totalPoints: 'Pontos disponíveis',
    viewDetails: 'Ver detalhes dos benefícios',
    pointsEarned: 'Ganhos',
    pointsUsed: 'Usados',
    pointsExpiring: 'A expirar',
    brandPoints: 'McDonald\'s',
    stores: ' lojas',
    pointsGuideTitle: 'Guia de pontos',
    pointsGuide1: 'Os pontos são acumulados automaticamente ao pagar',
    pointsGuide2: 'Os pontos são válidos por 1 ano a partir da data de acúmulo',
    pointsGuide3: 'Os pontos de cada marca só podem ser usados nessa marca',
    viewLocation: 'Ver localização',
    whatsapp: 'WhatsApp',
    pickup: 'Retirar agora',
    open: 'Aberto',
    closed: 'Fechado',
    category: 'Fast food',
    backToBrands: 'Voltar às marcas',
    availableStores: 'Lojas disponíveis'
  },
  fr: {
    tabs: {
      points: 'Points'
    },
    totalPoints: 'Points disponibles',
    viewDetails: 'Voir les détails des avantages',
    pointsEarned: 'Gagnés',
    pointsUsed: 'Utilisés',
    pointsExpiring: 'Expirent',
    brandPoints: 'McDonald\'s',
    stores: ' magasins',
    pointsGuideTitle: 'Guide des points',
    pointsGuide1: 'Les points sont cumulés automatiquement lors du paiement',
    pointsGuide2: 'Les points sont valables 1 an à partir de la date d\'obtention',
    pointsGuide3: 'Les points propres à une marque ne peuvent être utilisés que chez cette marque',
    viewLocation: 'Voir l\'emplacement',
    whatsapp: 'WhatsApp',
    pickup: 'Retirer maintenant',
    open: 'Ouvert',
    closed: 'Fermé',
    category: 'Restauration rapide',
    backToBrands: 'Retour aux marques',
    availableStores: 'Magasins disponibles'
  },
  zh: {
    tabs: {
      points: '积分'
    },
    totalPoints: '可用积分',
    viewDetails: '查看权益详情',
    pointsEarned: '已获得',
    pointsUsed: '已使用',
    pointsExpiring: '即将到期',
    brandPoints: 'McDonald\'s',
    stores: ' 家门店',
    pointsGuideTitle: '积分指南',
    pointsGuide1: '付款时会自动累积积分',
    pointsGuide2: '积分自获得日起 1 年内有效',
    pointsGuide3: '品牌积分只能在对应品牌使用',
    viewLocation: '查看位置',
    whatsapp: 'WhatsApp',
    pickup: '立即自取',
    open: '营业中',
    closed: '已关闭',
    category: '快餐',
    backToBrands: '返回品牌',
    availableStores: '可用门店'
  },
  ja: {
    tabs: {
      points: 'ポイント'
    },
    totalPoints: '利用可能ポイント',
    viewDetails: '特典の詳細を見る',
    pointsEarned: '獲得',
    pointsUsed: '使用済み',
    pointsExpiring: 'まもなく失効',
    brandPoints: 'McDonald\'s',
    stores: ' 店舗',
    pointsGuideTitle: 'ポイントガイド',
    pointsGuide1: '支払い時にポイントが自動で付与されます',
    pointsGuide2: 'ポイントは獲得日から 1 年間有効です',
    pointsGuide3: 'ブランド別ポイントはそのブランドでのみ使用できます',
    viewLocation: '場所を見る',
    whatsapp: 'WhatsApp',
    pickup: '今すぐ受け取り',
    open: '営業中',
    closed: '閉店',
    category: 'ファストフード',
    backToBrands: 'ブランド一覧へ戻る',
    availableStores: '利用可能店舗'
  },
  hi: {
    tabs: {
      points: 'अंक'
    },
    totalPoints: 'उपलब्ध अंक',
    viewDetails: 'लाभ विवरण देखें',
    pointsEarned: 'अर्जित',
    pointsUsed: 'उपयोग किए गए',
    pointsExpiring: 'समाप्त होने वाले',
    brandPoints: 'McDonald\'s',
    stores: ' स्टोर',
    pointsGuideTitle: 'अंक गाइड',
    pointsGuide1: 'भुगतान करते समय अंक अपने आप जुड़ते हैं',
    pointsGuide2: 'अंक अर्जित होने की तारीख से 1 वर्ष तक मान्य रहते हैं',
    pointsGuide3: 'ब्रांड-विशिष्ट अंक केवल उसी ब्रांड में उपयोग किए जा सकते हैं',
    viewLocation: 'स्थान देखें',
    whatsapp: 'WhatsApp',
    pickup: 'अभी पिकअप करें',
    open: 'खुला',
    closed: 'बंद',
    category: 'फास्ट फूड',
    backToBrands: 'ब्रांड पर वापस जाएं',
    availableStores: 'उपलब्ध स्टोर'
  },
  de: {
    tabs: {
      points: 'Punkte'
    },
    totalPoints: 'Verfügbare Punkte',
    viewDetails: 'Vorteilsdetails ansehen',
    pointsEarned: 'Gesammelt',
    pointsUsed: 'Verwendet',
    pointsExpiring: 'Verfallen bald',
    brandPoints: 'McDonald\'s',
    stores: ' Filialen',
    pointsGuideTitle: 'Punkte-Leitfaden',
    pointsGuide1: 'Punkte werden bei jeder Zahlung automatisch gesammelt',
    pointsGuide2: 'Punkte sind ab dem Sammeldatum 1 Jahr gültig',
    pointsGuide3: 'Markenpunkte können nur bei dieser Marke verwendet werden',
    viewLocation: 'Standort ansehen',
    whatsapp: 'WhatsApp',
    pickup: 'Jetzt abholen',
    open: 'Geöffnet',
    closed: 'Geschlossen',
    category: 'Fast Food',
    backToBrands: 'Zurück zu Marken',
    availableStores: 'Verfügbare Filialen'
  },
  it: {
    tabs: {
      points: 'Punti'
    },
    totalPoints: 'Punti disponibili',
    viewDetails: 'Vedi dettagli dei vantaggi',
    pointsEarned: 'Guadagnati',
    pointsUsed: 'Usati',
    pointsExpiring: 'In scadenza',
    brandPoints: 'McDonald\'s',
    stores: ' negozi',
    pointsGuideTitle: 'Guida ai punti',
    pointsGuide1: 'I punti vengono accumulati automaticamente al pagamento',
    pointsGuide2: 'I punti sono validi per 1 anno dalla data di accumulo',
    pointsGuide3: 'I punti di un marchio possono essere usati solo presso quel marchio',
    viewLocation: 'Vedi posizione',
    whatsapp: 'WhatsApp',
    pickup: 'Ritira ora',
    open: 'Aperto',
    closed: 'Chiuso',
    category: 'Fast food',
    backToBrands: 'Torna ai marchi',
    availableStores: 'Negozi disponibili'
  },
  ru: {
    tabs: {
      points: 'Баллы'
    },
    totalPoints: 'Доступные баллы',
    viewDetails: 'Посмотреть сведения о преимуществах',
    pointsEarned: 'Заработано',
    pointsUsed: 'Использовано',
    pointsExpiring: 'Истекает',
    brandPoints: 'McDonald\'s',
    stores: ' филиалов',
    pointsGuideTitle: 'Руководство по баллам',
    pointsGuide1: 'Баллы автоматически начисляются при оплате',
    pointsGuide2: 'Баллы действительны в течение 1 года с даты начисления',
    pointsGuide3: 'Баллы конкретного бренда можно использовать только у этого бренда',
    viewLocation: 'Посмотреть местоположение',
    whatsapp: 'WhatsApp',
    pickup: 'Забрать сейчас',
    open: 'Открыто',
    closed: 'Закрыто',
    category: 'Фастфуд',
    backToBrands: 'Назад к брендам',
    availableStores: 'Доступные филиалы'
  },
  ar: {
    tabs: {
      points: 'النقاط'
    },
    totalPoints: 'النقاط المتاحة',
    viewDetails: 'عرض تفاصيل المزايا',
    pointsEarned: 'المكتسبة',
    pointsUsed: 'المستخدمة',
    pointsExpiring: 'تنتهي قريبًا',
    brandPoints: 'McDonald\'s',
    stores: ' فروع',
    pointsGuideTitle: 'دليل النقاط',
    pointsGuide1: 'تُضاف النقاط تلقائيًا عند الدفع',
    pointsGuide2: 'النقاط صالحة لمدة سنة واحدة من تاريخ اكتسابها',
    pointsGuide3: 'نقاط كل علامة تجارية قابلة للاستخدام لدى تلك العلامة فقط',
    viewLocation: 'عرض الموقع',
    whatsapp: 'WhatsApp',
    pickup: 'استلام الآن',
    open: 'مفتوح',
    closed: 'مغلق',
    category: 'وجبات سريعة',
    backToBrands: 'العودة إلى العلامات',
    availableStores: 'الفروع المتاحة'
  },
  vi: {
    tabs: {
      points: 'Điểm'
    },
    totalPoints: 'Điểm khả dụng',
    viewDetails: 'Xem chi tiết quyền lợi',
    pointsEarned: 'Đã tích',
    pointsUsed: 'Đã dùng',
    pointsExpiring: 'Sắp hết hạn',
    brandPoints: 'McDonald\'s',
    stores: ' cửa hàng',
    pointsGuideTitle: 'Hướng dẫn điểm',
    pointsGuide1: 'Điểm được tự động tích lũy khi thanh toán',
    pointsGuide2: 'Điểm có hiệu lực trong 1 năm kể từ ngày tích lũy',
    pointsGuide3: 'Điểm theo thương hiệu chỉ dùng được tại thương hiệu đó',
    viewLocation: 'Xem vị trí',
    whatsapp: 'WhatsApp',
    pickup: 'Nhận ngay',
    open: 'Đang mở',
    closed: 'Đã đóng',
    category: 'Đồ ăn nhanh',
    backToBrands: 'Quay lại thương hiệu',
    availableStores: 'Cửa hàng khả dụng'
  },
  th: {
    tabs: {
      points: 'คะแนน'
    },
    totalPoints: 'คะแนนที่ใช้ได้',
    viewDetails: 'ดูรายละเอียดสิทธิประโยชน์',
    pointsEarned: 'ได้รับ',
    pointsUsed: 'ใช้แล้ว',
    pointsExpiring: 'ใกล้หมดอายุ',
    brandPoints: 'McDonald\'s',
    stores: ' สาขา',
    pointsGuideTitle: 'คู่มือคะแนน',
    pointsGuide1: 'คะแนนจะสะสมโดยอัตโนมัติเมื่อชำระเงิน',
    pointsGuide2: 'คะแนนมีอายุ 1 ปีนับจากวันที่ได้รับ',
    pointsGuide3: 'คะแนนของแต่ละแบรนด์ใช้ได้เฉพาะกับแบรนด์นั้น',
    viewLocation: 'ดูตำแหน่ง',
    whatsapp: 'WhatsApp',
    pickup: 'รับตอนนี้',
    open: 'เปิดอยู่',
    closed: 'ปิด',
    category: 'อาหารจานด่วน',
    backToBrands: 'กลับไปยังแบรนด์',
    availableStores: 'สาขาที่ใช้ได้'
  },
  nl: {
    tabs: {
      points: 'Punten'
    },
    totalPoints: 'Beschikbare punten',
    viewDetails: 'Bekijk voordeelgegevens',
    pointsEarned: 'Verdiend',
    pointsUsed: 'Gebruikt',
    pointsExpiring: 'Verlopen binnenkort',
    brandPoints: 'McDonald\'s',
    stores: ' winkels',
    pointsGuideTitle: 'Puntengids',
    pointsGuide1: 'Punten worden automatisch gespaard bij betaling',
    pointsGuide2: 'Punten zijn 1 jaar geldig vanaf de spaardatum',
    pointsGuide3: 'Merkpunten kunnen alleen bij dat merk worden gebruikt',
    viewLocation: 'Locatie bekijken',
    whatsapp: 'WhatsApp',
    pickup: 'Nu ophalen',
    open: 'Open',
    closed: 'Gesloten',
    category: 'Fastfood',
    backToBrands: 'Terug naar merken',
    availableStores: 'Beschikbare winkels'
  }
} satisfies Record<Locale, PointsTranslations>;

export function getPointsTranslations(locale: Locale): PointsTranslations {
  return translations[locale];
}

export const mockFranchises: Franchise[] = [
  {
    id: 'mcdonalds',
    name: '맥도날드',
    category: '패스트푸드',
    logo: imgBrandLogo,
    storeCount: 5,
    points: 1250,
    rating: 4.3,
    stores: [
      {
        id: 'md-1',
        name: '맥도날드 강남점',
        address: '서울시 강남구 강남대로 123',
        rating: 4.5,
        hours: '06:00 - 24:00',
        distance: '0.8km',
        isOpen: true,
        phone: '+82-2-1234-5678'
      },
      {
        id: 'md-2',
        name: '맥도날드 홍대점',
        address: '서울시 마포구 홍익로 456',
        rating: 4.2,
        hours: '24시간',
        distance: '1.2km',
        isOpen: true,
        phone: '+82-2-2345-6789'
      },
      {
        id: 'md-3',
        name: '맥도날드 신촌점',
        address: '서울시 서대문구 신촌로 789',
        rating: 4.0,
        hours: '07:00 - 23:00',
        distance: '1.5km',
        isOpen: false,
        phone: '+82-2-3456-7890'
      },
      {
        id: 'md-4',
        name: '맥도날드 종로점',
        address: '서울시 종로구 종로 321',
        rating: 4.3,
        hours: '06:30 - 23:30',
        distance: '2.1km',
        isOpen: true,
        phone: '+82-2-4567-8901'
      },
      {
        id: 'md-5',
        name: '맥도날드 이태원점',
        address: '서울시 용산구 이태원로 654',
        rating: 4.4,
        hours: '24시간',
        distance: '2.8km',
        isOpen: true,
        phone: '+82-2-5678-9012'
      }
    ]
  },
  {
    id: 'burgerking',
    name: '버거킹',
    category: '패스트푸드',
    logo: imgBrandLogo,
    storeCount: 4,
    points: 850,
    rating: 4.2,
    stores: [
      {
        id: 'bk-1',
        name: '버거킹 강남역점',
        address: '서울시 강남구 역삼로 234',
        rating: 4.3,
        hours: '10:00 - 22:00',
        distance: '0.9km',
        isOpen: true,
        phone: '+82-2-2222-3333'
      },
      {
        id: 'bk-2',
        name: '버거킹 명동점',
        address: '서울시 중구 명동길 567',
        rating: 4.1,
        hours: '09:00 - 23:00',
        distance: '1.5km',
        isOpen: true,
        phone: '+82-2-3333-4444'
      },
      {
        id: 'bk-3',
        name: '버거킹 홍대입구점',
        address: '서울시 마포구 양화로 890',
        rating: 4.4,
        hours: '24시간',
        distance: '1.8km',
        isOpen: true,
        phone: '+82-2-4444-5555'
      },
      {
        id: 'bk-4',
        name: '버거킹 잠실점',
        address: '서울시 송파구 올림픽로 123',
        rating: 4.2,
        hours: '10:00 - 23:00',
        distance: '3.2km',
        isOpen: false,
        phone: '+82-2-5555-6666'
      }
    ]
  },
  {
    id: 'kfc',
    name: 'KFC',
    category: '패스트푸드',
    logo: imgBrandLogo,
    storeCount: 3,
    points: 620,
    rating: 4.0,
    stores: [
      {
        id: 'kfc-1',
        name: 'KFC 신촌점',
        address: '서울시 서대문구 연세로 456',
        rating: 4.0,
        hours: '11:00 - 22:00',
        distance: '1.3km',
        isOpen: true,
        phone: '+82-2-6666-7777'
      },
      {
        id: 'kfc-2',
        name: 'KFC 이대점',
        address: '서울시 서대문구 이화여대길 789',
        rating: 4.1,
        hours: '11:00 - 23:00',
        distance: '1.7km',
        isOpen: true,
        phone: '+82-2-7777-8888'
      },
      {
        id: 'kfc-3',
        name: 'KFC 강남점',
        address: '서울시 강남구 테헤란로 321',
        rating: 4.3,
        hours: '10:30 - 22:30',
        distance: '2.5km',
        isOpen: true,
        phone: '+82-2-8888-9999'
      }
    ]
  }
];

export const defaultPointsData: PointsData = {
  totalPoints: 5000,
  pointsEarned: 1250,
  pointsUsed: 500,
  pointsExpiring: 1000
};
